export default "__VITE_ASSET__67925281__"